import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse, HttpParams } from '@angular/common/http';
import * as pbi from 'powerbi-client';

const apiServer = environment.apiServer;

@Component({
  selector: 'app-home-report',
  templateUrl: './home-report.component.html',
  styleUrls: ['./home-report.component.sass']
})
export class HomeReportComponent implements OnInit {

  constructor(private http: HttpClient) { }

  ngOnInit() {

    const groupId = 'edbb70cf-0b9e-4fb6-a212-7e0c05193269';
    const reportId = 'f6c39e2c-8ea2-4319-b260-1296c49203ec';

    this.http.get(`${apiServer}/report`, { params: { ReportIdPBI: reportId, GroupIdPBI: groupId } })
      .subscribe((embedToken) => {
        this.initReport(document.getElementById('container'), embedToken, reportId, groupId);
      });

  }

  initReport(container, embedToken, reportIdPBI, groupIdPBI) {
    const models = pbi.models;
    const permissions = models.Permissions.All;

    //let embedToken = 'H4sIAAAAAAAEAB2Wxa7FCo5F_-VNU1KYSqpBmJkzC9MJc1r973275vaWvbZl-3_-sbP3N2flP__-Z363r4vbjoAznCp-G-rk_hNVV6GpQhn4w-yT7HNK7ZA4U1Q6m3QAmtJVM5oSO-XHYj9GImmkXvjGF9D5-bnxfihR9sgrlik7TanP2XEFZnvgnRYZwFp4k8gVoTR8y5fuWeRc8GnH1JOw3EseWI_-lgVN4avUk-u0AsmzU-7BIvYxKJ0-yU8YpHupzhf8eEf39N4Ge0laeEsZ_b5iE3t0OtZMvh_G9G4sprQ-hgYNSeTdJcE9YjADUvH97eKavSXvekN31kvtPPH6GwvgT3HqpiiQkjxcUpWFCE-ZbY2rQR05FiajPGQT4sDH7eQa-tc6trOt_E3XfKP9WJjB9YxmRxlt9PMp7zhMZvQreoPIj2Glw9o_DAomLvG-uC7Mu_Mm1SvD49_eeFUvgq6ZmocEcf6CpV0iWRZEE6EhcS6L7O6Ic-Iv0PFqRQMiwVR2Ffrn6T7BRoa30cW7lP7IKwqWMUTBN7OxRdb33ijnmc70nPanzl2rA6xAyj7zAbcXPs_D-1PjMVFCm1eMW7ovEU4H5k6VlY3r6Wz22OnHQXoXWCQZtQqbL7pzIRooJNtr2D_LeBUTgCcv-sDegakWpBuO6I-kkz-nfBXwMlBpf-3kNhMuJdA1SE2XIpRHzaEMkMBzTWP94oP4nMl-4nUKCQJ42TeH6uRu1KPZnFijFo5kXfqO3IyJqfQQfw2cB2VEkQfK4MNXs-kKdm136_dF78_0MUM-j8qd_B7LQQlBdvCT8smRiLXfvR-QCbFscWTPam-b4BGO7ZDD8vjraY2-aD273k4Qq6ugi70cv5UcV4pnTsAffdTE5H7ha1mRtxxzlbPBy9rFKjs7QAQELmkp_oTIucbc9vIrLb2pm6Xmrls5Rrd8xUxJfUS3iMcyz411_TOeDP1Y5H0Qu8K4v5Q-zskkOS_KTApLC5Tp1-J282cBa9L2hduCRlk1AsACOEdTpTjX4jYZUXV0Hqhrnzxxxxf6hIBjH7QRXvBoPxpUVt-Bb9z16PZu9gVJsoBctTyNFKvKp-CCvx51HYuM96PRua0u1FL1pVfqMk-FQSzKsZCcTHQOsV8Z4VfSuX92A_Kn8iBMnKgQ_VdjCw3EODvo_SvoVGcDbbgP49NQILxpvFaibPsrHlgyinUwXX3giPIeVo1bdJR19L5OdocTHjHIZAwqI1Dby_Zf7oGHJM-UJrjonPZrcPPTqey7aUS1Iag-FKAzwC946BH4QHETgcFppqhssBsC--W9nJk340HIJwMKRhcRKAVaaz3bFboJ6iYVAyMIurXzqMB_mvMCtjTHs5-FuzclC5V1nUvMeXzeXYsgoxGHL4ecYzgpvXE3-jU8G76RTpQAhIdLMdG0iQPl4raBWsRyO61LyLx8zy_XNlmhSEGUW4_XSGqgEupBTyKAyM3Mw0noxCbcjt7TUuzegyAMqjU-FIruk6swsDy9lNZbvalRrDk6D2aJlT3UawMd3gOssol5R2YQu6dUgc-3vu5sUBvzg5W24A3XDf6rPMs-L5u2Hf-kFvmnzFuuEKhKi3llkG44dRrXnurxHjiRC2bfB52lIIupvr-4ljrH_iLq-4JPf8OdgQRHE2YcPbtUvqfQQ79gou4s27ivpRwjKPSFN4h14iCqAotfp3UvgaFOMXAhvWfKX5PPW_eaYrANM6FxNu6ScI_mZha8sawV_7a1y1AYSsswXYjl_Sxhn-Ul1Mke7dZNHXs-V_nwWhImegHl-biqVGb56jN5EhzLZYpcySAorprPgsgPE480MfO6YfmL5tMBLOs8hzFD53XNUFPj8q3EI59X4Jt2A98LPZU_QGZt36aCsuUuDuYBu6ZF8KtdEqecWEMOaGvJIEkFwRIyBFpvOBVnx0M64Q4RjclYtp019Za8SOvkFfdfUtGJM1Fk8ZotsOwO3mLFRxgaX5but-oZWFM3W-WUdkrLi9vHdISORP1ie37fIpKQBk9pEIZQzUvW0VDrrx3nhICsSv31Ook2CFYaYgjFayH76_qgMQigIU4MZuh62cUBIEeVITw_sFSECpbczr3pjYbs1N-RS7kf-Xdn7OQRuyxlLNhg3Gpz0E3CKOozPPAFqdJaAPZnqHfwn3_-9c_fZvtbfVr1_r0Ow28ardAWXDW6mg8YwGa_UTOEkHubPrGa-z7-8TZ4I9fkvhwgqPAAErm6Us7yQjd2vVLUm47w--U4gJkOyaG2mhm_jpaeuTaZGOTQ_AKxSzzMqwjcdQbIKTJK7LpRAotdGoY4bxsvR-KP1pzaHF_Sbb7vPLul19pkUQg2H7YA_QQyS_EhC1AE9GKfxGP8MsmDnixXRTvqMgHMMtp1P2vaZaHG7bHDpvrmiLauIE2ba5bbtvaE-XGcJ02FU1jfNBZjQ2jkbw85wd3RmJpqiAB8j6S83eNUa9wo6qhnlokaUUJqge6Z-nBLjznmr2H1qlbVJhiA4gAiuapnfh-4o7jlJL3_81_M79JWmxL-UV75q1ToMw937GNsYmJGzQWZ_0b9TfGUHedW_YX9QmCdiKOaknFM3nT1Q_8hRYZfICdeqw12HBIK3I9CXyOuKJ0oFKemFJrpUKlCruM3DgN9rl42vSzkuG4MKIcFq2h1SmlyPKaT4Dr-8tszciz7qs9O_DlmxeNd2O1Bv225i9AGM8xAdL-HWba9Hb4a9hEs-ayYxzbvaM_HiWfleYVZJTDSjspixwz5u6EmtMOaZEsRa5ML__F6bNcQ3CCAnBmkhIUqNAGRRVJ1lj0ZvvDL114_NSBxL8rlruMj_kNntFOPi7rPWW8Cq7NV9sP1vllRw0PERbmnxOVweKggYTHwB-AXdx_cu3RcQM59SFxac6Us95ExVHaj9cOeoRRu9v8x_-__AYgLHEcuCwAA';
    //const filter = groupIdPBI !== null ? this.creatorFilters("reports_v_dim_GroupPlanogramm", "GPID", [parseInt(groupId)]) : null;
    const embedURL = `https://app.powerbi.com/reportEmbed?reportId=${reportIdPBI}groupId=${groupIdPBI}`;
    const config = {
      type: 'report',
      tokenType: models.TokenType.Embed,
      accessToken: embedToken,
      embedUrl: embedURL,
      id: reportIdPBI,
      permissions: permissions,
      settings: {
        filterPaneEnabled: false,
        navContentPaneEnabled: false
      }
    } as pbi.IEmbedConfiguration;
    let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);

    if (powerbi.embed.length !== 0)
      powerbi.reset(container);

    let report = powerbi.embed(container, config);

    // Report.off removes a given event handler if it exists.
    report.off("loaded");

    // Report.on will add an event handler which prints to Log window.
    report.on("loaded", function () {
      console.log("Loaded");
    });
  }

  creatorFilters(table, column, values) {
    return {
      schema: "http://powerbi.com/product/schema#basic",
      target: {
        table,
        column
      },
      operator: "In",
      values,
      filterType: pbi.models.FilterType.Basic,
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-report/home-report.component.ts